import {useState} from 'react';
import {createElement} from 'react-native';
import PropTypes from 'prop-types';

import {getTodayAt0Hours, toLocalISOString} from '../../../utils/date';

function DatePicker({value, onChange, style}) {
  let initialDate = value;
  try {
    initialDate = toLocalISOString(initialDate);
  } catch (error) {
    initialDate = toLocalISOString(getTodayAt0Hours());
  }

  const [date, setDate] = useState(initialDate);

  const handleInput = event => setDate(event.target.value);

  const handleBlur = event => {
    let selectedDate = null;
    try {
      selectedDate = new Date(event.target.value);
    } catch (e) {
      selectedDate = new Date();
    }
    onChange(selectedDate);
  };

  return createElement('input', {
    type: 'date',
    onInput: handleInput,
    value: date,
    onBlur: handleBlur,
    style,
  });
}

DatePicker.propTypes = {
  value: PropTypes.instanceOf(Date).isRequired,
  onChange: PropTypes.func.isRequired,
  style: PropTypes.object,
};

DatePicker.defaultProps = {
  style: {},
};

export default DatePicker;
